import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import {
  IFilter,
  IQueryParam,
  IPopulate,
  ICamara,
  IDispositivoAlarma,
} from 'modelos/src';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogService } from '../../../../auxiliares/dialog/dialog.service';
import { HelperService } from '../../../../auxiliares/servicios/helper.service';
import {
  CamarasService,
  IsAliveResult,
} from '../../../../auxiliares/servicios/http/camara.service';
import { Lista2Service } from '../../../../auxiliares/servicios/lista2.service';
import {
  ParamsService,
  IParamsService,
} from '../../../../auxiliares/servicios/params.service';
import {
  IRegExpSearch,
  IFiltroTabla,
} from '../../../../auxiliares/tabla/filtro/filtro.component';
import {
  IColumnas,
  ICrearBoton,
  IEstadoCelda,
} from '../../../../auxiliares/tabla/tabla.interfaces';
import { LoginService } from '../../../login/login.service';
import { CamarasMultipleComponent } from '../../../standalone/camaras-multiple/camaras-multiple.component';
import {
  IDescargarVideoCamaraData,
  DescargarVideoCamaraComponent,
} from '../../../standalone/descargar-video-camara/descargar-video-camara.component';
import { ClienteJerarquiaService } from '../../../../auxiliares/servicios/cliente-jerarquia.service';
import { FormularioDialogService } from '../../../../auxiliares/servicios/formulario-dialog.service';

@Component({
  selector: 'app-listado-camaras',
  templateUrl: './listado-camaras.component.html',
  styleUrl: './listado-camaras.component.scss',
  standalone: false,
})
export class ListadoCamarasComponent implements OnInit, OnDestroy {
  private clienteJerarquia = inject(ClienteJerarquiaService);
  private lista2 = inject(Lista2Service);
  helper = inject(HelperService);
  private dialogService = inject(DialogService);
  private service = inject(CamarasService);
  dialog = inject(MatDialog);
  private formularios = inject(FormularioDialogService);
  private navigator = inject(Router);
  private route = inject(ActivatedRoute);
  private paramsService = inject(ParamsService);

  public name = 'ListadoCamarasComponent';
  public clientePropio = LoginService.getCliente();
  public dialogDescargaAbierto = false;
  public isAliveMap: Record<string, IsAliveResult> = {};
  public isAliveLoading = new Set<string>();
  //// Tabla nueva
  public datos?: ICamara[];
  public totalCount = 0;
  public columnas?: IColumnas<ICamara>[];
  //Subs
  public datos$?: Subscription;
  public alarmas$?: Subscription;
  //
  public botonCrear: ICrearBoton = {
    mostrar: this.helper.tienePermiso('Cámaras - Crear cámara'),
    tooltip: 'Crear cámara',
    color: 'primary',
    tipo: 'material',
    icon: 'add',
    accion: () => this.crear(),
  };
  // FILTROS
  public search: IRegExpSearch = {
    fields: ['identificacion', 'numeroSerie', 'host'],
  };

  //filtro cliente
  public cliente: IFiltroTabla = {
    filter: {
      field: 'idCliente',
    },
    label: 'Cliente',
    tipo: 'cliente-selector',
    filtroSelector: ['moduloCamaras'],
  };
  // Cliente en cuya jerarquía cuelga la entidad: el cliente elegido y toda su
  // descendencia.
  public ancestro: IFiltroTabla = {
    filter: {
      field: 'idsAncestros',
      incluirPropio: true,
    },
    label: 'En la jerarquía de',
    tipo: 'cliente-selector',
  };

  //filtro modelo
  public modelo: IFiltroTabla = {
    elementos: [],
    filter: {
      field: 'idModeloDispositivo',
    },
    label: 'Modelo',
    selectLabel: 'label',
    selectValue: '_id',
    tipo: 'ngselect',
  };
  //filtro tipo
  public tipo: IFiltroTabla = {
    elementos: [
      { value: 'Hikvision' },
      { value: 'Dahua' },
      { value: 'Hikvision P2P' },
      { value: 'Dahua P2P' },
    ],
    filter: {
      field: 'tipo',
    },
    label: 'Tipo',
    rapido: true,
    selectLabel: 'value',
    selectValue: 'value',
    tipo: 'select',
  };
  public filtros: IFiltroTabla[] = [this.modelo, this.tipo];

  //Query
  public filter: IFilter<ICamara> = {};
  public populate: IPopulate[] = [
    {
      path: 'modeloDispositivo',
      select: 'marca modelo',
    },
    {
      path: 'cliente',
      select: 'nombre',
    },
  ];
  public query: IQueryParam = {
    filter: JSON.stringify(this.filter),
    populate: JSON.stringify(this.populate),
    sort: 'identificacion',
    page: 0,
    limit: +this.helper.getPageSize(this.name),
    includeChildren: true,
    childrenLevel: 0,
  };

  private tieneValor(value: unknown): boolean {
    if (typeof value === 'string') {
      return value.trim().length > 0;
    }
    return value !== undefined && value !== null;
  }

  private obtenerCamposFaltantesStream(camara: ICamara): string[] {
    const faltantes: string[] = [];
    const numeroSerie = camara.numeroSerie?.trim?.() || '';

    if (!this.tieneValor(camara.tipo)) {
      faltantes.push('Tipo');
    }

    if (!camara.canales || camara.canales.length === 0) {
      faltantes.push('Canales');
    }

    switch (camara.tipo) {
      case 'Hikvision':
      case 'Dahua':
        if (!this.tieneValor(camara.host)) {
          faltantes.push('Host');
        }
        if (!this.tieneValor(camara.puertoRTSP)) {
          faltantes.push('Puerto RTSP');
        }
        if (
          camara.tipo === 'Dahua' &&
          numeroSerie.length > 0 &&
          numeroSerie.length < 15
        ) {
          faltantes.push('Número de Serie (min. 15 caracteres)');
        }
        break;

      case 'Hikvision P2P':
        if (!this.tieneValor(camara.numeroSerie)) {
          faltantes.push('Número de Serie');
        }
        if (numeroSerie.length > 0) {
          if (numeroSerie.length > 9) {
            faltantes.push('Número de Serie (máx. 9 caracteres)');
          }
          if (!/^[a-zA-Z0-9]+$/.test(numeroSerie)) {
            faltantes.push('Número de Serie (solo letras y números)');
          }
        }
        // Desde que se sacó el fallback por entorno, sin estas dos no hay
        // stream posible: la API corta antes de spawnear el binario del SDK.
        if (!this.tieneValor(camara.credencialesHikvision?.appKey)) {
          faltantes.push('App Key');
        }
        if (!this.tieneValor(camara.credencialesHikvision?.secretKey)) {
          faltantes.push('Secret Key');
        }
        break;

      case 'Dahua P2P':
        if (!this.tieneValor(camara.numeroSerie)) {
          faltantes.push('Número de Serie');
        }
        if (numeroSerie.length > 0 && numeroSerie.length < 15) {
          faltantes.push('Número de Serie (min. 15 caracteres)');
        }
        // App Key / Secret Key / Product ID no se piden acá: son opcionales,
        // la cámara transmite sin ellas.
        break;
    }

    return faltantes;
  }

  public camaraEstaOnline(camara: ICamara): boolean {
    if (!camara.tipo) return true;
    const estado = this.isAliveMap[camara._id]?.estado;
    // Con credenciales rechazadas el equipo está online: se deja abrir para
    // reintentar (p. ej. si la cuenta estaba bloqueada y ya se liberó).
    return estado === 'online' || estado === 'credenciales rechazadas';
  }

  public camaraCompletaParaStream(camara: ICamara): boolean {
    return this.obtenerCamposFaltantesStream(camara).length === 0;
  }

  /**
   * Estado de la cámara con texto: primero lo que falta para el stream,
   * después lo que responde la plataforma (isAlive).
   */
  public getEstadoCamara(camara: ICamara): IEstadoCelda {
    const faltantes = this.obtenerCamposFaltantesStream(camara);

    if (faltantes.length > 0) {
      return {
        texto: 'Configuración incompleta',
        tono: 'aviso',
        icono: 'warning',
        tooltip: `Incompleta para stream. Faltan: ${faltantes.join(', ')}`,
      };
    }

    if (this.isAliveLoading.has(camara._id)) {
      return {
        texto: 'Consultando…',
        tono: 'info',
        icono: 'hourglass_top',
        tooltip: 'Consultando estado...',
      };
    }

    const alive = this.isAliveMap[camara._id];
    if (alive) {
      switch (alive.estado) {
        case 'online':
          return { texto: 'En línea', tono: 'ok', icono: 'cloud_done' };
        case 'offline':
          return { texto: 'Sin conexión', tono: 'error', icono: 'cloud_off' };
        case 'no encontrada':
          return {
            texto: 'No encontrada',
            tono: 'aviso',
            icono: 'warning',
            tooltip: 'No encontrada en la plataforma propietaria',
          };
        case 'error de credenciales':
          return {
            texto: 'Sin credenciales',
            tono: 'aviso',
            icono: 'key',
            tooltip: 'Faltan las credenciales de Hik-Partner Pro',
          };
        case 'credenciales rechazadas':
          return {
            texto: 'Credenciales rechazadas',
            tono: 'aviso',
            icono: 'key',
            tooltip:
              'En línea, pero el equipo rechazó el usuario o la contraseña en el último intento. Revisá las credenciales cargadas.',
          };
        default:
          return {
            texto: alive.estado
              ? alive.estado.charAt(0).toUpperCase() + alive.estado.slice(1)
              : 'Desconocido',
            tono: 'neutro',
            icono: 'question_mark',
            tooltip: `Estado: ${alive.estado}`,
          };
      }
    }

    return {
      texto: 'Completa',
      tono: 'ok',
      icono: 'check_circle',
      tooltip: 'Completa para stream',
    };
  }

  public getEstadoClaveEncriptacion(camara: ICamara): string {
    if (camara.tipo !== 'Hikvision P2P') {
      return 'No aplica';
    }

    return this.tieneValor(camara.claveDeEncriptacion) ? 'Sí' : 'No';
  }

  public getTextoModelo(camara: ICamara): string {
    const marca = (camara.modeloDispositivo?.marca || '').trim();
    const modelo = (camara.modeloDispositivo?.modelo || '').trim();

    if (!marca && !modelo) return '';

    let text = [marca, modelo].filter(Boolean).join(' - ');
    if (text.length >= 50) text = text.slice(0, 50) + '...';

    return text;
  }

  // Listados

  public async listar(): Promise<void> {
    this.datos$?.unsubscribe();
    this.datos$ = this.lista2.camaras(this.query, 30).subscribe((data) => {
      this.totalCount = data.totalCount;
      this.datos = data.datos;
      this.cargarEstadosVivos(data.datos);
    });
  }

  private cargarEstadosVivos(camaras: ICamara[]): void {
    const conCheck = camaras.filter((c) => {
      if (c.tipo) return !!c._id;
      else return false;
    });
    for (const camara of conCheck) {
      if (this.isAliveMap[camara._id] || this.isAliveLoading.has(camara._id)) {
        continue;
      }
      this.isAliveLoading.add(camara._id);
      this.service
        .isAlive(camara._id)
        .then((result) => {
          this.isAliveMap[camara._id] = result;
        })
        .catch(() => {
          this.isAliveMap[camara._id] = {
            encontrada: false,
            online: null,
            estado: 'desconocido',
          };
        })
        .finally(() => {
          this.isAliveLoading.delete(camara._id);
        });
    }
  }

  public async listarAlarma(id: string) {
    const filter: IFilter<IDispositivoAlarma> = {
      idsCamaras: { $in: [id] },
    };
    const query: IQueryParam = {
      filter: JSON.stringify(filter),
    };
    this.alarmas$?.unsubscribe();
    let asignado = '';
    this.alarmas$ = this.lista2
      .dispositivosAlarmas(query, 30)
      .subscribe((data) => {
        if (data.datos.length > 0) {
          asignado = data.datos[0].nombre;
        } else {
          asignado = '';
        }
      });

    return asignado;
  }

  // Acciones
  public async crear() {
    const params: IParamsService = {};
    this.paramsService.setParams(params);
    this.navigator.navigate(['crear'], { relativeTo: this.route });
  }

  public async editar(camara: ICamara) {
    const params: IParamsService = {
      edit: camara,
    };
    this.paramsService.setParams(params);
    this.navigator.navigate(['editar', camara._id], {
      relativeTo: this.route,
    });
  }

  public async detalles(camara: ICamara) {
    this.navigator.navigate(['detalles', camara._id], {
      relativeTo: this.route,
    });
  }

  public abrirDialogDescargarVideo(camara: ICamara): void {
    if (this.dialogDescargaAbierto) {
      return;
    }

    const data: IDescargarVideoCamaraData = {
      idCamara: camara._id,
      nombreCamara: camara.identificacion,
    };

    this.dialogDescargaAbierto = true;
    const dialogRef = this.formularios.abrir(DescargarVideoCamaraComponent, {
      tamano: 'chico',
      data: data,
    });

    dialogRef.afterClosed().subscribe(() => {
      this.dialogDescargaAbierto = false;
    });
  }

  public async verStream(camara: ICamara) {
    const dialogs = this.dialog.openDialogs;
    const idAbierto = dialogs.find(
      (d) =>
        d.componentInstance.data &&
        d.componentInstance.data.includes(camara._id),
    );
    if (!idAbierto) {
      CamarasMultipleComponent.open(this.dialog, { data: [camara._id] });
    }
  }

  public async eliminar(camara: ICamara) {
    const asignado = await this.listarAlarma(camara._id);
    let res = await this.dialogService.confirm(
      'Eliminar cámara',
      `¿Querés eliminar la cámara ${camara.identificacion} (${camara.modeloDispositivo?.marca || 'Marca'}, ${camara.modeloDispositivo?.modelo || 'Modelo'})?`,
    );
    if (!res) return;
    if (asignado) {
      res = await this.dialogService.confirm(
        'Eliminar cámara',
        `La cámara está asignada a la alarma ${asignado} ¿Querés eliminarla igualmente?`,
      );
      if (!res) return;
    }
    try {
      await this.service.delete(camara._id!);
      this.helper.notifSuccess('Eliminado correctamente');
      await this.listar();
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  // Tabla

  private setColumnas() {
    const columnas: IColumnas<ICamara>[] = [
      // Identificación
      {
        header: {
          label: 'Identificación',
        },
        row: {
          field: 'identificacion',
          noData: 'Sin identificación',
        },
      },
    ];

    // Tipo
    columnas.push({
      header: {
        label: 'Tipo',
        sortable: true,
      },
      row: {
        field: 'tipo',
        noData: 'Sin tipo',
      },
    });

    // Modelo
    columnas.push({
      header: {
        label: 'Marca - modelo',
      },
      row: {
        parse: (dato) => this.getTextoModelo(dato),
        noData: 'Sin modelo',
      },
    });

    columnas.push({
      header: {
        label: 'Clave de encriptación',
      },
      row: {
        parse: (dato) => this.getEstadoClaveEncriptacion(dato),
      },
    });

    // Host
    columnas.push({
      header: {
        label: 'Host / número de serie',
        sortable: false,
      },
      row: {
        parse(dato) {
          if (dato.host) {
            let text = dato.host;
            if (text.length >= 50) {
              text = text.slice(0, 50);
              text += '...';
            }
            return text;
          }
          if (dato.numeroSerie) {
            let text = dato.numeroSerie;
            if (text.length >= 50) {
              text = text.slice(0, 50);
              text += '...';
            }
            return text;
          }

          return '';
        },
        noData: 'Sin host ni número de serie',
      },
    });

    // Número de canales: sin el arreglo, falta de dato (no un 0 inventado)
    columnas.push({
      header: {
        label: 'Número de canales',
      },
      row: {
        parse(dato) {
          if (dato.canales && Array.isArray(dato.canales)) {
            return dato.canales.length;
          }
          return undefined;
        },
        noData: 'Sin canales',
      },
    });

    columnas.push({
      header: {
        label: 'Estado',
      },
      row: {
        estado: (dato) => this.getEstadoCamara(dato),
      },
    });

    // Cliente
    if (HelperService.getTipoCliente() !== 'Final') {
      // Cliente
      columnas.push({
        header: {
          label: 'Cliente',
        },
        row: {
          html: (dato) => this.clienteJerarquia.htmlNombre(dato.cliente),
          tooltip: (dato) =>
            this.clienteJerarquia.tooltipJerarquia(dato.cliente),
        },
      });
    }

    // Acciones (orden y submenú Más acciones como estaban)
    columnas.push({
      header: {
        label: 'Acciones',
      },
      row: {
        accionesGrouped: [
          // Ver detalle
          {
            tipo: 'material',
            color: 'primary',
            icon: 'visibility',
            tooltip: 'Ver detalle',
            click: (dato) => this.detalles(dato),
          },
          // Editar
          {
            tipo: 'material',
            color: 'primary',
            icon: 'edit',
            tooltip: 'Editar',
            click: (dato) => this.editar(dato),
            disabled: () =>
              !this.helper.tienePermiso('Cámaras - Editar cámara'),
          },
          // Eliminar
          {
            tipo: 'material',
            color: 'warn',
            icon: 'delete',
            tooltip: 'Eliminar',
            click: (dato) => this.eliminar(dato),
            disabled: () =>
              !this.helper.tienePermiso('Cámaras - Eliminar cámara'),
          },
          // ... Más
          {
            tipo: 'material',
            icon: 'more_vert',
            tooltip: 'Más acciones',
            children: [
              // Ver stream
              {
                tipo: 'material',
                color: 'primary',
                icon: 'videocam',
                tooltip: 'Ver en vivo',
                click: (dato) => this.verStream(dato),
                disabled: (dato) =>
                  !this.helper.tienePermiso('Cámaras - Ver streaming') ||
                  !this.camaraCompletaParaStream(dato) ||
                  !this.camaraEstaOnline(dato),
              },
              // Descargar video
              {
                tipo: 'material',
                color: 'primary',
                icon: 'file_download',
                tooltip: 'Descargar video',
                click: (dato) => this.abrirDialogDescargarVideo(dato),
                disabled: (dato) =>
                  this.dialogDescargaAbierto ||
                  !this.helper.tienePermiso('Cámaras - Ver streaming') ||
                  dato.tipo !== 'Dahua P2P' ||
                  !this.camaraCompletaParaStream(dato) ||
                  !this.camaraEstaOnline(dato),
              },
            ],
          },
        ],
      },
    });

    this.columnas = columnas;
  }

  // Hooks

  private async cargarFiltrosModelos(): Promise<void> {
    const filter: IFilter<any> = { tipo: { $in: ['Cámara', 'NVR'] } };
    const query: IQueryParam = {
      unlimited: true,
      select: 'marca modelo',
      filter: JSON.stringify(filter),
    };
    this.lista2.modeloDispositivos(query).subscribe((data) => {
      this.modelo.elementos = data.datos.map((m) => ({
        ...m,
        label: [m.marca, m.modelo].filter(Boolean).join(' - '),
      }));
    });
  }

  async ngOnInit() {
    if (HelperService.getTipoCliente() !== 'Final') {
      this.filtros.push(this.cliente);
      this.filtros.push(this.ancestro);
    }
    this.setColumnas();
    await Promise.all([this.listar(), this.cargarFiltrosModelos()]);
  }

  async ngOnDestroy() {
    this.datos$?.unsubscribe();
    this.alarmas$?.unsubscribe();
  }
}
